__turbopack_context__.v({
  "locate_code_error": "LocateCodeInput-module-scss-module__QKOsBa__locate_code_error",
  "locate_code_input": "LocateCodeInput-module-scss-module__QKOsBa__locate_code_input",
  "locate_code_input__button": "LocateCodeInput-module-scss-module__QKOsBa__locate_code_input__button",
  "locate_code_input__form": "LocateCodeInput-module-scss-module__QKOsBa__locate_code_input__form",
  "locate_code_input__headline": "LocateCodeInput-module-scss-module__QKOsBa__locate_code_input__headline",
  "locate_code_input__input": "LocateCodeInput-module-scss-module__QKOsBa__locate_code_input__input",
  "locate_code_input__text": "LocateCodeInput-module-scss-module__QKOsBa__locate_code_input__text",
});
